import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 21.6V18A3.6 3.6 0 0 1 6 14.4h6m7.029-.9 2.571 2.4m0 0-2.571 2.4m2.571-2.4H15M14.4 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0"
    />
  </svg>
);
export default SvgUserProfileRight;
